import { TabController } from 'mol-ui';
import { config } from 'config';
import { useTranslation } from 'react-i18next';
import {
    AbsenceRateConfiguration,
    GeneralConfigurations
} from './components';
import React, { useState } from 'react';
const {
    allowGlobalCallRates,
    diagnosisLicense,
    recording,
    recipesFiles
} = config;

const ABSENCE_RATE_CONFIGURATION = 'AbsenceRateConfiguration';
const GENERAL_CONFIGURATION = 'GeneralConfiguration';

const ConfigScreen = () => {

    const { t } = useTranslation();
    const [selected, setSelected] = useState(GENERAL_CONFIGURATION);

    const displayGeneral = allowGlobalCallRates || recipesFiles || recording;
    const displayAbsenceRate = diagnosisLicense;

    const renderCurrentTab = () => {
        switch (selected) {
        case (ABSENCE_RATE_CONFIGURATION): return <AbsenceRateConfiguration />;
        case (GENERAL_CONFIGURATION): return <GeneralConfigurations />;
        default: return displayGeneral ? <GeneralConfiguration /> : displayAbsenceRate ? <AbsenceRateConfiguration /> : null;
        }
    };

    return (
        <>
            <TabController
                items={ [{
                    display: displayGeneral,
                    key: GENERAL_CONFIGURATION,
                    label: t('Generales')
                }, {
                    display: displayAbsenceRate,
                    key: ABSENCE_RATE_CONFIGURATION,
                    label: t('Tasa de ausentismo')
                }] }
                margin="10px"
                value={ selected }
                onChange={ key => setSelected(key) }
            />
            {
                renderCurrentTab()
            }
        </>
    );
};

ConfigScreen.propTypes = {

};

export default ConfigScreen;

